// Password rules for new passwords (sign-up and reset). Checked in the
// browser; Supabase only enforces the minimum length on its side.

const PASSWORD_RULES = [
  (p) => p.length >= 8,
  (p) => /[A-Za-z]/.test(p),
  // Anything that isn't a letter, digit, or space counts as a symbol.
  (p) => /[^A-Za-z0-9\s]/.test(p),
];

// The first problem with a new password and its confirmation, or null if it's good.
export const passwordProblem = (password, confirm) => {
  if (!PASSWORD_RULES.every((rule) => rule(password))) {
    return "Your password needs at least 8 characters, a letter, and a symbol.";
  }
  if (password !== confirm) return "Those passwords don't match.";
  return null;
};
